import cn from 'classnames';
import { LevelDefinition } from 'libs/end-to-end/src/types/databases/dimensions/level-definition';
import React, { useMemo } from 'react';
import { LevelDefinitionIcon } from 'apps/sigma2-ui/src/components/LevelDefinitionIcon';
import { ConfigColors } from 'libs/end-to-end/src/types/branding/colors';

export const LevelDefinitionButton = (props: {
  disabled?: boolean;
  selected: boolean;
  levelDefinition: LevelDefinition;
  icon?: boolean;
  onSelect?: (isSelected: boolean) => void;
}) => {
  const { disabled, selected, levelDefinition, onSelect, icon } = props;

  const demographicLabel = levelDefinition.displayName;

  const classNames = useMemo(() => {
    return cn(
      'flex flex-row items-center font-sans text-xs gap-1 border-1 py-2 px-3 rounded-full border-gray-300 whitespace-nowrap',
      {
        'text-white': selected,
        'text-black': !selected,
      },
      selected
        ? ConfigColors[levelDefinition.color]['Primary'].bg
        : ConfigColors[levelDefinition.color]['Secondary'].bg,
    );
  }, [selected, levelDefinition]);

  return (
    <button
      disabled={disabled}
      className={classNames}
      onClick={() => {
        onSelect?.(!selected);
      }}
      type="button"
    >
      {icon && (
        <LevelDefinitionIcon
          levelDefinition={levelDefinition}
          focused={selected}
          additionalClasses={'w-3 h-3'}
        />
      )}
      {demographicLabel}
    </button>
  );
};
